<!--
 * @Author: qh_feng
 * @Date: 2022-03-18 22:02:22
 * @LastEditTime: 2022-12-19 15:54:40
 * @LastEditors: your name
 * @Description:
 * @ FilePath: Do not edit
 * @par 修改日志:
 * 内容:

 例子：
 this.$store.commit('boxDetail', {
        data: data,
        title: '详情',
        sort: [
          '企业税号',
          '创建时间',
          '企业名称',
          '联系方式',
          '企业法人',
          '企业执照',
          '法人身份证号',
          '法人营业执照',
          '企业类型',
          '法人身份证正面',
          '经验范围',
          '法人身份证反面',
          '注册时间',
          '企业状态',
          '入场时间',
          '审批状态',
          '企业位置',
          '审批意见'
        ]
      });
-->

<template>
  <div class="list u-w-100">
    <el-form
      v-if="computeData && computeData.length > 0"
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="150px"
      class="demo-ruleForm u-myflex u-flexwrap"
    >
      <el-form-item
        :label="item.title"
        class="u-w-50"
        v-for="(item, key) in computeData"
        :key="key"
      >
        <!-- :class="[key % 2 == 0 ? 'u-p5-r-2 u-border-c3c3c3 u-border-right' : '']" -->
        <el-form-item :prop="item.keyName">
          <!-- 做的双击就能修改，失去焦点就自动提交，不过某些项目未必适用，所以不开启 -->
          <span v-if="filterAttrObj[item.keyName] || filterAttrObj[item.keyName] === ''">
            <el-input
              v-model="filterAttrObj[item.keyName]"
              class="u-w-80"
              disabled
              size="mini"
              v-if="title == titleType[1]"
            ></el-input>
          </span>
          <span v-else>
            <el-select
              v-if="
                (item.type == 'select' || item.type == 'multiple') &&
                select2inputList.indexOf(item.keyName) < 0
              "
              :multiple="item.type == 'multiple'"
              v-model="ruleForm[item.keyName]"
              class="u-w-80"
              :disabled="!openInputList"
              size="mini"
              placeholder="无"
              filterable
            >
              <template v-if="item.keyName == 'vehicleBrand'">
                <el-option-group
                  v-for="(group, groupKey) in item.multipleOpt"
                  :key="groupKey"
                  :label="group.label"
                >
                  <el-option
                    v-for="(group2, groupKey2) in group.options"
                    :key="groupKey2"
                    :label="group2.name"
                    :value="group2.code"
                  >
                  </el-option>
                </el-option-group>
              </template>

              <template v-else-if="item.keyName == 'coId'">
                 <el-option
                  v-for="(item2, key2) in item.multipleOpt"
                  :key="'key2' + key2"
                  :label="item2.lable || '无'"
                  :value="
                    typeof ruleForm[item.keyName] == 'number'
                      ? Number(item2.value)
                      : item2.value
                  "
                ></el-option>
              </template>

              <template v-else>
                <el-option
                  v-for="(item2, key2) in item.multipleOpt"
                  :key="'key2' + key2"
                  :label="item2.name || '无'"
                  :value="
                    typeof ruleForm[item.keyName] == 'number'
                      ? Number(item2.code)
                      : item2.code || 1
                  "
                ></el-option>
              </template>
            </el-select>
            <!-- <template v-else-if="item.type == 'datetime'"> -->
            <template v-else-if="item.type == 'datetime'">
              <div
                v-if="item.keyName == 'validityPeriod'"
                class="u-myflex my-validityPeriod"
                style="margin-top: 4px"
              >
                <el-date-picker
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  unlink-panels
                  range-separator="至"
                  size="mini"
                  placeholder="选择日期"
                  :start-placeholder="
                    ruleForm[item.keyName].slice(0, ruleForm[item.keyName].indexOf(','))
                  "
                  :end-placeholder="
                    ruleForm[item.keyName].slice(ruleForm[item.keyName].indexOf(',') + 1)
                  "
                  :disabled="!openInputList"
                  v-model="validityPeriod"
                  :picker-options="validityPeriodPickerOptions"
                  align="right"
                  class="u-w-80"
                ></el-date-picker>
              </div>
              <el-date-picker
                v-else
                :value-format="
                  item.format != 'date' ? 'yyyy-MM-dd HH:mm:ss' : 'yyyy-MM-dd'
                "
                :type="item.format || 'datetime'"
                size="mini"
                placeholder="选择日期"
                @change="changeDatetime(item.keyName, key)"
                :disabled="!openInputList"
                v-model="ruleForm[item.keyName]"
                :picker-options="pickerOptions"
                align="right"
                class="u-w-80"
              ></el-date-picker>
            </template>
            <div class="my-time" v-else-if="item.type == 'time'">
              <!-- <el-time-picker
                v-if="item.keyName == 'passTime'"
                is-range
                value-format="HH:mm:ss"
                placeholder="选择时间"
                range-separator="-"
                size="mini"
                :start-placeholder="
                  ruleForm[item.keyName].slice(
                    0,
                    ruleForm[item.keyName].indexOf(passTimeGrid)
                  )
                "
                :end-placeholder="
                  ruleForm[item.keyName].slice(
                    ruleForm[item.keyName].indexOf(passTimeGrid) + 1
                  )
                "

                :disabled="!openInputList"
                v-model="passTime"
                class="u-w-80"
              ></el-time-picker> -->
              <el-time-picker
                v-if="item.keyName == 'passTime'"
                is-range
                value-format="HH:mm:ss"
                placeholder="选择时间"
                range-separator="-"
                size="mini"
                :disabled="!openInputList"
                v-model="passTime"
                class="u-w-80"
              ></el-time-picker>
              <el-time-picker
                v-else
                value-format="HH:mm:ss"
                placeholder="选择时间"
                size="mini"
                @change="changeDatetime(item.keyName, key)"
                :disabled="!openInputList"
                v-model="ruleForm[item.keyName]"
                class="u-w-80"
              ></el-time-picker>
            </div>
            <el-input
              v-else
              ref="input"
              v-model="ruleForm[item.keyName]"
              class="u-w-80"
              :disabled="!openInputList"
              size="mini"
              :placeholder="title == titleType[1] ? '无' : '请输入内容'"
            ></el-input>
          </span>
        </el-form-item>
      </el-form-item>
    </el-form>
    <div class="u-p5-y-2" v-if="uploadImgApi">
      <my-el-upload
        :on-success="onSuccess"
        :is-refresh-btn="openInputList"
        :list="imgList"
        ref="uploadImgEl"
        :upload-img-api="'/api' + uploadImgApi"
      ></my-el-upload>
    </div>
    <div class="u-text-center u-m5-t-2" v-if="openBtn">
      <el-button
        v-if="title == titleType[1] && !isEdit"
        class="u-m5-r-10"
        type="primary"
        @click="openEdit"
        >修改</el-button
      >
      <template v-else>
        <el-button class="u-m5-r-10" type="primary" @click="submitForm('ruleForm')">{{
          title == titleType[0] ? "立即添加" : "提交修改"
        }}</el-button>
        <el-button v-show="title == titleType[0]" class="u-m5-r-10" @click="resetForm"
          >重置表单</el-button
        >
      </template>
      <el-button
        v-if="approvalApi"
        class="u-m5-r-10"
        type="primary"
        @click="isApproval = true"
        >更新审批</el-button
      >
    </div>
    <el-dialog title="审批详情" :visible.sync="isApproval" width="60%" append-to-body>
      <div>
        <el-form ref="form" :model="approvalForm" label-width="120px">
          <el-form-item :label="checkStatus.title">
            <el-radio-group v-model="approvalForm.checkStatus">
              <el-radio
                class="u-color-c3"
                v-for="item in checkStatus.multipleOpt"
                :key="item.code"
                v-show="item.code != 0"
                :label="
                  typeof approvalForm.checkStatus == 'number'
                    ? Number(item.code)
                    : item.code
                "
                >{{ item.name || "无" }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="checkOpinion.title">
            <el-input type="textarea" v-model="approvalForm.checkOpinion"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="$emit('approval', approvalForm)"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MyElUpload from "@/components/My-el-upload";

export default {
  name: "List",
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    title: {
      //固定：新增、详情，我下面要判断动态处理属性，详情带修改功能
      type: String,
      default: "",
    },
    uploadImgApi: {
      type: String,
      default: "",
    },
    approvalApi: {
      type: String,
      default: "",
    },
    openBtn: {
      type: Boolean,
      default: true,
    },
  },
  components: { MyElUpload },
  data() {
    const titleType = ["新增", "详情"];
    // 过滤---后面修改人 和 创建人字段也加入filterAttr里面过滤，这些都不能改，也不传给后台
    const filterAttr = [
      "createtor",
      "modifytor",
      "createTime",
      "modifyTime",
      "checkTime",
      "checker",
      "checkOpinion",
      "checkStatus",
      "dispositionID",
      "deviceListName",
      "deviceID",
      //"tid"
      // 'dispositionStatus'//布控状态
    ];
    let select2inputList_filterAttr = ["tollgateID"];
    let select2inputList = [];
    let keepNumberType = [];
    let computeData = [];
    let imgList = [];
    let rules = {};
    let approvalForm = {};
    let checkOpinion = {};
    let checkStatus = {};
    let filterAttrObj = {};
    let ruleForm = {};
    let passTimeGrid = ",";
    this.data.forEach((item, index) => {
      const val = this.title == titleType[0] ? "" : item.value;
      select2inputList = this.title == titleType[1] ? select2inputList_filterAttr : [];
      let rulesType = "";
      switch (item.type) {
        case "text":
        case "radio":
          rulesType = null;
          break;
        // case "select":
        //   rulesType = null;
        //   break;
        case "checkbox":
          rulesType = "array";
          break;
        case "image":
          item.fileList = [
            {
              name: item.title,
              url: item.value,
            },
          ];
          if (this.title == titleType[0]) item.fileList = [];
          imgList.push(item);
          rulesType = null;
          break;
        case "datetime":
          break;
        case "time":
          if (typeof item.value == "string" && item.value.includes("-")) {
            passTimeGrid = "-";
          }
          // rulesType = 'date';
          rulesType = null; //因为我项目问题，将时间组件返回改为yyyy这类格式，所以type不能为 ’date‘类型
          break;
      }
      if (filterAttr.indexOf(item.keyName) > -1) {
        filterAttrObj[item.keyName] = val || "";
        if (item.keyName === "checkOpinion") {
          checkOpinion = item;
          approvalForm.checkOpinion = item.value || "";
        } else if (item.keyName === "checkStatus") {
          approvalForm.checkStatus = item.value;
          checkStatus = item;
        }
        if (this.title == titleType[1])
          if (item.type !== "image") {
            computeData.push(item);
            if (item.type == "select") {
              const obj = item.multipleOpt.find((params) => params.code == val);
              if (item.keyName === "checkStatus")
                filterAttrObj[item.keyName] = obj ? obj.name : "未审批";
              else filterAttrObj[item.keyName] = obj ? obj.name : "";
            }
          }
      } else {
        ruleForm[item.keyName] = val || "";
        if (item.type !== "image") computeData.push(item);
      }
      if (rulesType != "" && typeof item.value != "number" && filterAttr.indexOf(item.keyName) == -1) {
        rules[item.keyName] = [
          {
            required: true,
            message: "请输入",
            trigger: item.type === "text" ? "blur" : "change",
          },
        ];
        if (rulesType != null) {
          rules[item.keyName][0].type = rulesType;
        } else {
          if (typeof item.value === "number" && !isNaN(item.value))
            rules[item.keyName][0].type = "string";
          keepNumberType.push(item.keyName);
        }
      }
    });
    return {
      select2inputList, //专门存一些详情显示是字符串，点修改按钮时是下拉框的属性名
      passTime: null,
      passTimeGrid: passTimeGrid, //passTime分隔符
      validityPeriod: "",
      isApproval: false,
      checkOpinion,
      checkStatus,
      approvalForm,
      filterAttrObj,
      computeData,
      titleType,
      imgList,
      keepNumberType,
      isEdit: false,
      value1: "",
      ruleForm,
      // ruleForm: {
      // businessLicense:
      //   'https://dqipark.oss-accelerate.aliyuncs.com/driveOut/20220311/16469823981890.5891919544730321.jpg',
      // checkOpinion: '通过',
      // checkStatus: 1,
      // coAddress: '嘉兴市海盐县百步镇超同村工业园区姚储门',
      // coCreatetime: '2022-03-16T00:00:00',
      // coEin: '52',
      // coIntime: '2022-03-16T00:00:00',
      // coLicense:
      //   'https://dqipark.oss-accelerate.aliyuncs.com/driveOut/20220311/16469823981890.5891919544730321.jpg',
      // coName: '机械1啊1',
      // coPerson: '',
      // createTime: '2022-03-21T14:17:19',
      // idcardZheng:
      //   'https://dqipark.oss-accelerate.aliyuncs.com/driveOut/20220311/16469823981890.5891919544730321.jpg',
      // status: 0,
      // telphone: '213421534652'
      // },

      // rules:rules,//暂时不验证，后期他们弄好要求才加，上面做个数组验证 字段名内的才true就行
      rules: rules,
      openInputList: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      validityPeriodPickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  methods: {
    // getTimeFn(name) {
    //   this.ruleForm[name] = '';
    // },
    onSuccess(imgList, res, key) {
      this.imgList = imgList;
      this.imgList.forEach((params) => {
        let arr = [];
        params.fileList.forEach((item) => {
          arr.push(item.url);
        });
        this.ruleForm[params.keyName] = arr.join(",");
      });
    },
    openEdit() {
      this.select2inputList = [];
      this.openInputList = true;
      this.isEdit = true;
    },
    changeDatetime(attrName, index) {},
    submitForm(formName) {
      this.keepNumberType.forEach((params) => {
        this.ruleForm[params] = Number(this.ruleForm[params]);
      });
      console.log("aaaaaa", this.passTime);
      this.ruleForm.passTime =
        this.passTime && this.passTime.length ? this.passTime.join("-") : "";
      if (this.validityPeriod) {
        this.ruleForm.validityPeriodStart = this.validityPeriod[0];
        this.ruleForm.validityPeriodEnd = this.validityPeriod[1];
      }
      // this.ruleForm.carType = this.ruleForm.vehicleType;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const form = JSON.parse(JSON.stringify(this.ruleForm));
          this.$emit("submit", form);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      this.ruleForm = Object.assign({}, this.save_ruleForm);
      this.$refs.uploadImgEl.clearFiles();
    },
    // enterInput(key, item) {
    //   this.openInputList = true;
    //   this.refreshKey = 't' + new Date().getTime();
    //   if (item.type.indexOf('time') < 0)
    //     setTimeout(() => {
    //       this.$refs.input[key].focus();
    //     }, 50);
    // },
    initFormData() {
      if (this.data && this.data.length > 0) {
        this.keepNumberType = [];
        if (this.title == this.titleType[0]) this.openInputList = true;
        else this.openInputList = false;
        if (this.imgList.length) this.onSuccess(this.imgList); //因为又默认列表，要初始化一下表单数据
        this.save_ruleForm = Object.assign({}, this.ruleForm);
        if ("passTime" in this.save_ruleForm && this.save_ruleForm.passTime.length > 0) {
          this.passTime = this.save_ruleForm.passTime.split(this.passTimeGrid);
        }
      }
    },
  },
  created() {
    this.initFormData();
  },
};
</script>

<style lang="scss">
.list {
  .el-input.is-disabled .el-input__inner {
    color: #000;
    background-color: rgb(248, 248, 248);
    cursor: default;
  }
  .my-validityPeriod,
  .my-time {
    .el-range-editor,
    .el-range-input {
      background: #02133a !important;
      color: #fff;
      width: 44%;
      border: 1px solid #1057b4;
    }
    .el-range-editor.is-disabled,
    .is-disabled .el-range-input {
      width: 44%;
      background: #1057b4 !important;
      border-radius: 0;
      border: 1px solid #1057b4;
      color: #92c8fd !important;
    }
    .el-range-separator {
      padding-right: 16px;
    }
    .el-range__icon {
      display: none;
    }
  }
  // .el-date-editor.is-disabled.my-time,
  // .el-date-editor.is-disabled.my-time input {
  //   cursor: default;
  //   background: #1057b4 !important;
  //   border-radius: 0;
  //   border: 1px solid #1057b4;
  //   color: #92c8fd !important;
  // }
  // .el-date-editor .el-range-input {
  //   background: #02133a !important;
  //   color: #fff;
  //   border: 1px solid #1057b4;
  // }
  .el-form-item {
    margin-bottom: 0;
  }
  .el-form-item__error {
    left: 85%;
    top: 25%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cards-info/list.vue